import angular from 'angular'
import byLastItemsComponent from './by-last-items.component'
import byLastItemsConfig from './by-last-items.config'
import ByLastItemsController from './by-last-items.controller'
import ByLastItemsService from './by-last-items.service'

let byLastItems = angular.module('app.byLastItems', [])
  .component('byLastItems', byLastItemsComponent)
  .controller('ByLastItemsController', ByLastItemsController)
  .service('ByLastItemsService', ByLastItemsService)
  .config(byLastItemsConfig)

export default byLastItems



// WEBPACK FOOTER //
// ./www/components/fast-purchase/by-last-items/by-last-items.js